import { asMarionetteView } from "lib/common/hoc/BackboneReact/asMarionetteView";
import DrawerLayout from "lib/common/drawer/DrawerLayout";
import { BackboneDataQualityResultsLayout as ResultsView } from "./results/DataQualityResultsLayout";

const MarionetteResultsView = asMarionetteView(ResultsView);

class DataQualityReportLayout extends DrawerLayout {
    constructor(...args) {
        super(...args);
        this.onChangeSearchResults = this.onChangeSearchResults.bind(this);
    }

    onChangeSearchResults() {
        this.onDrawerEnable();
        this.onDrawerClose();

        const rv = new MarionetteResultsView({model: this.model});
        this.content.show(rv);
    }
}

DataQualityReportLayout.prototype.el = "#content_dqr";

DataQualityReportLayout.prototype.modelEvents = {
    "change:searchResults": "onChangeSearchResults"
};

export default DataQualityReportLayout;



// WEBPACK FOOTER //
// ./app/lib/dqr/views/DataQualityReportLayout.js